/**
 * DE STUURTEKEN-WAL VAN DE DRAAD — één waarheid voor elk publiek formulier
 * (#678 R1 AW-4 voor de Objekt-Anfrage; micro-B B1 trekt hem door naar Vor-Ort).
 *
 * C0 (`U+0000–U+001F`), DEL en C1 (`U+007F–U+009F`) zijn in GEEN tekstveld
 * toegestaan — alleen de regelopvoeding (LF) waar een veld dat expliciet toelaat
 * (de nachricht). Een CR (ook als CRLF), een tab of een NUL op de draad is nooit
 * een mens die in een formulier typt (een textarea levert LF; de widgets
 * normaliseren vóór het verzenden), en een NUL laat Postgres de hele transactie
 * weigeren (22021 → 500). Daarom wordt niets genormaliseerd: de wal staat VÓÓR de
 * trim, zodat ook een stuurteken aan de rand een 400 is. Unicode-letters (Zoë,
 * Çelik, Ørsted) zijn GEEN stuurtekens en gaan gewoon door.
 *
 * Tekencodes, geen regex — dan is er geen stuurteken in de broncode nodig.
 */
export function ohneSteuerzeichen(wert, lfErlaubt = false) {
    for (let i = 0; i < wert.length; i++) {
        const c = wert.charCodeAt(i);
        if (c === 10 && lfErlaubt)
            continue;
        if (c <= 0x1f || (c >= 0x7f && c <= 0x9f))
            return false;
    }
    return true;
}
